import { Moment } from "moment";
import { Plan } from "./plan";

export enum ClientType {
  DEMO = 'demo',
  PROSPECT = 'prospect',
  CLIENT = 'client',
}

export interface OrganizationSubscription {
  plan: string,
  additionalVolume?: number,
  additionalTrademarks?: number,
  additionalCases?: number,
  additionalCrawlerUrl?: number
}

export interface OrganizationSubscriptionPlan {
  plan?: Plan,
  additionalVolume?: number,
  additionalTrademarks?: number,
  additionalCases?: number,
  additionalCrawlerUrl?: number
}

export interface Organization {
  _id?: string;
  name: string;
  createdAt: Moment;
  logo?: string;
  headquartersAddress?: string;
  clientType?: ClientType;
  organizationId: string;
  isSuspended: boolean;
  subscription?: OrganizationSubscriptionPlan
  /** UZ.IP's own organisation, whose Super Admins hold the platform rights. Set by migration only. */
  platform?: boolean;
}
